import React, {useState, useEffect} from 'react'
import {Style} from './Style'

const File = (props) => {
  const [state, setState] = useState({
    name: '',
    thumbnail: ''
  })

  const setFile = (e, type) => {
    const file = e.target.files[0]

    if (file) {
      const reader = new FileReader()
      reader.onloadend = () => {
        setState({
          ...state,
          name: file.name,
          thumbnail: reader.result,
        })
        props.onChange({
          file: file,
          thumb: reader.result
        })
      }
      reader.readAsDataURL(file)
      e.target.value = ''
    }
  }

  useEffect(() => {
    setState({
      ...state,
      thumbnail: props.thumbnail
    })
  }, [props.thumbnail])

  return (
    <Style.Container>
      <Style.Content>
        <Style.Input
            type="file"
            id={props.name}
            name={props.name}
            placeholder={props.placeholder}
            accept={props.accept}
            onChange={(e) => setFile(e, props.name)}
        />
        <Style.Label htmlFor={props.name}>
          {state.thumbnail && props.isTransform ? (
            <Style.ImgContainer
              width={props.width}
              height={props.height}
              radius={props.radius}
            >
              <Style.Img
                src={state.thumbnail}
                alt="thumbnail"
              />
            </Style.ImgContainer>
          ) : (
            <Style.Text>
              {state.name && props.isTransform ? state.name : props.placeholder}
            </Style.Text>
          )}
        </Style.Label>
      </Style.Content>
    </Style.Container>
  )
}

export default File
